import Entity from "@/services/westore/entities/entity";

export class Development extends Entity {
  static uri = "/v1/tokens";

  static store(payloadRequest) {
    return super.create(`${Development.uri}/create`, payloadRequest);
  }

  static getPermissions(params = {}) {
    return super.getAll(`${Development.uri}/permissions-list`, params);
  }

  static getAll(params = {}) {
    return super.getAll(Development.uri, params);
  }

  static revoke(id) {
    let uri = `${Development.uri}/${id}/revoke`;
    return super.post({ uri });
  }
  static getOne(id, params = {}) {
    return super.get(Development.uri, id, params);
  }
  static update(params = {}) {
    let uri = `${Development.uri}/update`;
    return super.put({ uri, payload: params });
  }

  static export(type = "xlsx", filter) {
    const endpoint = `${Development.uri}/export?type=${type}`;
    return super.get(endpoint, null, filter);
  }
}
